import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, mergeMap, catchError, filter} from 'rxjs/operators';
import {AiBuilderService} from "../../websites/website/ai-builder/service/ai-builder.service";
import {LOAD_USED_AI_CREDITS, LoadUsedAiCreditsSuccess} from "../../store/actions";
import * as usedAiCreditsActions from '../actions/used-ai-credits.actions';

@Injectable()
export class UsedAiCreditsEffects {
  loadUsedAiCredits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(usedAiCreditsActions.LOAD_USED_AI_CREDITS),
      mergeMap(() => this._aiBuilderService.getUsedAiCreditsCount().pipe(
          map((resp) => {
            return new usedAiCreditsActions.LoadUsedAiCreditsSuccess({credits: resp?.data})
          }),
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private _aiBuilderService: AiBuilderService,
  ) {
  }
}
